/** Stored in place of a null expiresAt so lexical comparison still works. */
export const PRO_FOREVER_SENTINEL = '9999-12-31T00:00:00.000Z';

/**
 * Pro is active while proUntil is in the future; absent/null/empty is never active.
 * The lexical comparison needs full ISO UTC strings as toISOString() writes them;
 * date-only or offset forms misorder.
 */
export function isProActive(
  proUntil: string | null | undefined,
  now: string = new Date().toISOString()
): boolean {
  return !!proUntil && proUntil > now;
}

/** The wire's `isSupporter`: present and true, or absent so it is not sent. */
export function supporterFlag(
  proUntil: string | null | undefined,
  now?: string
): true | undefined {
  return isProActive(proUntil, now) || undefined;
}
